import { checkoutPageAttributes, checkoutHelper } from '@/modules/billing/store/billing.state';
import { CheckoutPageAttributesObject } from '@/modules/billing/models/CheckoutPageAttributesObject';

export function setCheckoutPageAttributes(attributes: CheckoutPageAttributesObject): void {
  checkoutPageAttributes.value = attributes;
}

export function setStripeIsComplete(completeness: boolean): void {
  checkoutHelper.value.stripeIsComplete = completeness;
}

export function setUpliftIsComplete(completeness: boolean): void {
  checkoutHelper.value.upliftTokenIsAvailable = completeness;
}

export function setPaymentButtonIsLoading(loading: boolean): void {
  checkoutHelper.value.paymentButtonIsLoading = loading;
}

export function setPaymentMethod(method?: string): void {
  checkoutHelper.value.paymentMethod = method;
}
